// extracted by mini-css-extract-plugin
module.exports = {"customer-carousel":"customer-carousel","fold":"fold","customer-card":"customer-card","loading":"loading","large-height":"large-height"};